/**
 * retryParkedStep - Regras puras do botão "Reexecutar etapa" (BR-WF-EXEC-001).
 *
 * O botão só aparece na página Execuções, para quem pode editar execuções,
 * em processos ativos ou aguardando e fora de revisão. O servidor
 * (`workflow_retry_parked_step`) revalida tudo.
 *
 * CHANGELOG:
 *   RELEASE: 2026-10-17 v1.0.0 - Versão inicial.
 */

/** Situações em que um processo pode ter etapa parada reexecutada */
export const SITUACOES_REEXECUTAVEIS = ['ativo', 'aguardando'] as const;

export interface ContextoReexecucao {
  /** Habilitado somente pela página Execuções */
  permitidoNaTela: boolean;
  /** Permissão "editar" em workflow_executions (ou administrador) */
  podeEditar: boolean;
  status: string | null | undefined;
  emRevisao?: boolean | null;
}

/** Decide se o botão "Reexecutar etapa" deve aparecer */
export function podeReexecutarEtapa(c: ContextoReexecucao): boolean {
  if (!c.permitidoNaTela || !c.podeEditar) return false;
  if (c.emRevisao) return false;
  return (SITUACOES_REEXECUTAVEIS as readonly string[]).includes(String(c.status ?? ''));
}

export interface ResultadoReexecucao {
  avancou: boolean;
  destinos: { de: string | null; para: string | null }[];
  etapas_avaliadas: number;
}

/** Mensagem exibida ao gestor após a reexecução */
export function mensagemReexecucao(r: ResultadoReexecucao): string {
  if (!r.avancou) return 'A condição ainda não foi atendida. O processo continua parado nesta etapa.';
  const para = r.destinos.map((d) => d.para).filter(Boolean).join(', ');
  return para ? `Avançou para: ${para}` : 'O processo avançou.';
}
